import { render } from "./AddTypeDocumentModal.vue?vue&type=template&id=3f45ba52&ts=true"
import script from "./AddTypeDocumentModal.vue?vue&type=script&lang=ts"
export * from "./AddTypeDocumentModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__